/**
 * This file is auto-generated from ChatQuestion.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const enterMeasurement: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Please enter a value';
        case 'pl':
            return 'Proszę podać wartość';
    }
};
